import { Injectable } from '@angular/core';

@Injectable()
export class TableParamService {
  constructor() {}

  getFarmColumns(): any {
    return {
      tableConf: [
        {
          key: 'name',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item1',
        },
        {
          key: 'street1',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item5',
        },
        {
          key: 'city',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item6',
        },
        {
          key: 'country',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item4',
        },
      ],
      searchParam: 'name,city,country,street1',
    };
  }

  getSupplierColumns(): any {
    return {
      tableConf: [
        {
          key: 'name',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item1',
          icon: 'glyphicon glyphicon-sort',
          sort: true,
        },
        {
          key: 'vat',
          index: null,
          subKey: null,
          translateString: 'store.invoiceData.vat',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'referentName',
          translateString: 'companyData.tab1.label_references',
        },
        {
          key: 'addresses',
          index: 0,
          subKey: 'city',
          translateString: 'settingslist.tab2_page.item6',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'email',
          translateString: 'settingslist.tab2_page.item3',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'phone',
          translateString: 'settingslist.tab2_page.item2',
        },
      ],
      searchParam: 'name',
    };
  }

  getCustomerColumns(): any {
    return {
      tableConf: [
        {
          key: 'name',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item1',
          icon: 'glyphicon glyphicon-sort',
          sort: true,
        },
        {
          key: 'vat',
          index: null,
          subKey: null,
          translateString: 'store.invoiceData.vat',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'referentName',
          translateString: 'companyData.tab1.label_references',
        },
        {
          key: 'addresses',
          index: 0,
          subKey: 'city',
          translateString: 'settingslist.tab2_page.item6',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'email',
          translateString: 'settingslist.tab2_page.item3',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'phone',
          translateString: 'settingslist.tab2_page.item2',
        },
      ],
      searchParam: 'name',
    };
  }

  getEmployeeColumns(): any {
    return {
      tableConf: [
        {
          key: 'firstName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab1_page.item1',
        },
        {
          key: 'lastName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab1_page.item2',
        },
        {
          key: 'roleTMP',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.column4',
        },
        {
          key: 'loginCheckTMP',
          index: null,
          subKey: null,
          translateString: 'companyData.tab5.login_label',
        },
        {
          key: 'typeOfContract',
          index: null,
          subKey: null,
          translateString: 'companyData.tab2.contract_type',
        },
        {
          key: 'email',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item3',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'phone',
          translateString: 'settingslist.tab2_page.item2',
        },
      ],
      searchParam: 'firstName, lastName',
    };
  }

  getEmployeeIncompleteColumns(): any {
    return {
      tableConf: [
        {
          key: 'firstName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab1_page.item1',
        },
        {
          key: 'lastName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab1_page.item2',
        },
        {
          key: 'contacts',
          index: 0,
          subKey: 'email',
          translateString: 'settingslist.tab2_page.item3',
        },
      ],
      searchParam: 'firstName, lastName',
    };
  }

  getUserColumns(): any {
    return {
      tableConf: [
        {
          key: 'firstName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.firstName',
        },
        {
          key: 'lastName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.lastName',
        },
        {
          key: 'username',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.column3',
        },
        {
          key: 'authorities',
          index: 0,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.column4',
        },
      ],
      searchParam: 'firstName,lastName,username',
    };
  }

  getTagColumns(): any {
    return {
      tableConf: [
        {
          key: 'tagName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.firstName',
        },
      ],
      searchParam: 'tagName',
    };
  }

  getExternalCompanies(): any {
    return {
      tableConf: [
        {
          key: 'farmName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab2_page.item1',
        },
        {
          key: 'userFullName',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.firstName',
        },
        {
          key: 'username',
          index: null,
          subKey: null,
          translateString: 'settingslist.tab3_page.table_detail_people.column3',
        },
        {
          key: 'dateCreated',
          index: 3,
          subKey: null,
          translateString: 'settingslist.linkedDate',
        },
      ],
      searchParam: 'farmName,name,username',
    };
  }
}
